<template>
  <v-container class="pt-10 pb-12">
    <Title> {{ title }} </Title>

    <div
      v-if="text"
      class="text-body-2 font-weight-regular mt-8"
      v-html="text"
    ></div>

    <Gallery v-if="images.length" :images="images" class="mt-8" />
  </v-container>
</template>

<script>
import Title from "../widgets/Title.vue";
import Gallery from "./Gallery.vue";

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: "",
    },
    images: {
      type: Array,
    },
  },
  components: {
    Title,
    Gallery,
  },
};
</script>
